import React, { useRef } from 'react';
import { LuCamera, LuImage, LuX } from 'react-icons/lu';
import { construirUrlFoto } from '../../utils/construirUrlFoto';
import { comprimirFoto, fileADataUrl } from './FotoUpload';

// Fotos del trabajo (14-oct-2026): hasta 4 por trabajo, sin "antes/después". Pueden ser data URLs
// (recién sacadas) o nombres de archivo ya subidos; quien guarda sube las nuevas con subirFotosTrabajo.
export const MAX_FOTOS = 4;
const verFoto = f => (String(f).startsWith('data:') ? f : construirUrlFoto(f));

export default function FotosTrabajo({ fotos = [], onChange, titulo = 'Fotos del trabajo', ayuda = true }) {
    const refCamara = useRef(null);
    const refGaleria = useRef(null);
    const quedan = MAX_FOTOS - fotos.length;

    const agregar = async (e) => {
        const files = [...(e.target.files || [])].slice(0, quedan);
        e.target.value = '';
        const nuevas = [];
        for (const f of files) { const d = await fileADataUrl(await comprimirFoto(f)); if (d) nuevas.push(d); }
        if (nuevas.length) onChange([...fotos, ...nuevas].slice(0, MAX_FOTOS));
    };
    const sacar = (i) => onChange(fotos.filter((_, j) => j !== i));

    return (
        <section className="space-y-2">
            <div className="flex items-baseline justify-between gap-2">
                <p className="text-label font-black text-muted uppercase tracking-widest">{titulo}</p>
                <span className="text-label text-muted">{fotos.length}/{MAX_FOTOS}</span>
            </div>
            <div className="grid grid-cols-4 gap-2">
                {fotos.map((f, i) => (
                    <div key={i} className="relative aspect-square rounded-xl overflow-hidden bg-chip">
                        <img src={verFoto(f)} alt={`Foto ${i + 1}`} className="w-full h-full object-cover" />
                        <button type="button" onClick={() => sacar(i)} aria-label={`Sacar foto ${i + 1}`}
                            className="absolute top-1 right-1 w-6 h-6 rounded-full bg-black/60 text-white flex items-center justify-center"><LuX size={13} /></button>
                    </div>
                ))}
                {quedan > 0 && (
                    <div className={`aspect-square rounded-xl border border-dashed border-black/15 dark:border-white/15 grid ${fotos.length ? 'grid-rows-2' : 'grid-rows-2'}`}>
                        <button type="button" onClick={() => refCamara.current?.click()} className="flex items-center justify-center gap-1 text-label font-black text-brand-red border-b border-dashed border-black/10 dark:border-white/10">
                            <LuCamera size={14} /> Cámara
                        </button>
                        <button type="button" onClick={() => refGaleria.current?.click()} className="flex items-center justify-center gap-1 text-label font-black text-secondary">
                            <LuImage size={14} /> Galería
                        </button>
                    </div>
                )}
            </div>
            {ayuda && fotos.length === 0 && <p className="text-caption text-muted">Opcional. Salen en el PDF y en el historial del trabajo.</p>}
            <input ref={refCamara} type="file" accept="image/*" capture="environment" className="hidden" onChange={agregar} />
            <input ref={refGaleria} type="file" accept="image/*" multiple className="hidden" onChange={agregar} />
        </section>
    );
}
